import Layout from '@/page/index/'

export default [
  {
    path: '/wel',
    component: Layout,
    redirect: '/wel/index',
    children: [
      {
        path: 'index',
        name: '首页',
        component: () => import(/* webpackChunkName: "views" */ '@/page/wel'),
      },
    ],
  },
  {
    path: '/user',
    component: Layout,
    redirect: '/user/center',
    children: [
      {
        path: 'center',
        name: '修改密码',
        component: () => import(/* webpackChunkName: "views" */ '@/views/user/index'),
      },
    ],
  },
  {
    path: '/media',
    component: Layout,
    children: [
      {
        path: 'wechat',
        name: '微信',
        component: () => import(/* webpackChunkName: "views" */ '@/views/media/wechat/index'),
      },
      {
        path: 'wechat/edit',
        name: '微信编辑',
        component: () => import(/* webpackChunkName: "views" */ '@/views/media/edit'),
      },
      {
        path: 'weibo/edit',
        name: '微博编辑页',
        component: () => import(/* webpackChunkName: "views" */ '@/views/media/edit'),
      },
      {
        path: 'redbook/edit',
        name: '小红书编辑',
        component: () => import(/* webpackChunkName: "views" */ '@/views/media/edit'),
      },
      {
        path: 'tiktok/edit',
        name: '抖音编辑',
        component: () => import(/* webpackChunkName: "views" */ '@/views/media/edit'),
      },
      {
        path: 'bilibili/edit',
        name: 'B站编辑',
        component: () => import(/* webpackChunkName: "views" */ '@/views/media/edit'),
      },
      {
        path: 'kwai/edit',
        name: '快手编辑',
        component: () => import(/* webpackChunkName: "views" */ '@/views/media/edit'),
      },
      {
        path: 'taobao/edit',
        name: '淘宝编辑',
        component: () => import(/* webpackChunkName: "views" */ '@/views/media/edit'),
      },
    ]
  },
  {
    path: '/media/weiboAnalysis',
    component: Layout,
    redirect: '',
    children: [
      {
        path: 'add',
        name: '创建监测任务',
        component: () => import(/* webpackChunkName: "views" */ '@/views/media/weiboAnalysis/add'),
      },
      {
        path: 'report',
        name: '分析报告',
        component: () => import(/* webpackChunkName: "views" */ '@/views/media/weiboAnalysis/report'),
      },
      {
        path: 'article',
        name: '文章列表',
        component: () => import(/* webpackChunkName: "views" */ '@/views/media/weiboAnalysis/article-list'),
      }
    ]
  },
  {
    path: '/business',
    component: Layout,
    redirect: '',
    children: [
      {
        path: 'contract/edit',
        name: '编辑合同',
        component: () => import(/* webpackChunkName: "views" */ '@/views/business/contract/edit'),
      },
      {
        path: 'contract/show',
        name: '查看合同',
        component: () => import(/* webpackChunkName: "views" */ '@/views/business/contract/show'),
      },
      {
        path: 'contract/media-related',
        name: '博主关联合同',
        component: () => import(/* webpackChunkName: "views" */ '@/views/business/contract/media/relate-contract'),
      },
      {
        path: 'contract/relate-delivery',
        name: '合同关联投放记录',
        component: () => import(/* webpackChunkName: "views" */ '@/views/business/contract/relate-delivery'),
      },
    ]
  },
  {
    path: '/businessTest',
    component: Layout,
    redirect: '',
    children: [
      {
        path: 'contract/edit',
        name: '编辑合同',
        component: () => import(/* webpackChunkName: "views" */ '@/views/businessTest/contract/edit'),
      },
      {
        path: 'contract/show',
        name: '查看合同',
        component: () => import(/* webpackChunkName: "views" */ '@/views/business/contract/show'),
      },
      {
        path: 'contract/media-related',
        name: '博主关联合同',
        component: () => import(/* webpackChunkName: "views" */ '@/views/business/contract/media/relate-contract'),
      },
      {
        path: 'contract/relate-delivery',
        name: '合同关联投放记录',
        component: () => import(/* webpackChunkName: "views" */ '@/views/business/contract/relate-delivery'),
      },
    ]
  },
  {
    path: '/business',
    component: Layout,
    redirect: '',
    children: [
      {
        path: 'delivery-log/edit',
        name: '编辑投放',
        component: () => import(/* webpackChunkName: "views" */ '@/views/business/delivery/edit'),
      },
      {
        path: 'delivery-log/show',
        name: '查看投放',
        component: () => import(/* webpackChunkName: "views" */ '@/views/business/delivery/show'),
      }
    ]
  },
  {
    path: '/business',
    component: Layout,
    redirect: '',
    children: [
      {
        path: 'backMoney/edit',
        name: '回款认领',
        component: () => import(/* webpackChunkName: "views" */ '@/views/business/backMoney/business/edit'),
      },
      {
        path: 'contract/backMoney',
        name: '回款认领',
        component: () => import(/* webpackChunkName: "views" */ '@/views/business/contract/component/backMoney'),
      },
      {
        path: 'frameAccord/edit',
        name: '编辑框架协议',
        component: () => import(/* webpackChunkName: "views" */ '@/views/business/frameAccord/edit'),
      },
    ]
  },
  {
    path: '/brand',
    component: Layout,
    redirect: '',
    children: [
      {
        path: 'brandList/edit',
        name: '编辑品牌',
        component: () => import(/* webpackChunkName: "views" */ '@/views/brand/brandList/edit'),
      },
    ]
  },
  {
    path: '/officialSeal',
    component: Layout,
    redirect: '',
    children: [
      {
        path: 'brandSeal/edit',
        name: '查看品牌合同',
        component: () => import(/* webpackChunkName: "views" */ '@/views/officialSeal/brandSeal/edit'),
      },
    ]
  },
  {
    path: '/supplier',
    component: Layout,
    redirect: '',
    children: [
      {
        path: 'supplier/edit',
        name: '编辑品牌供应商',
        component: () => import(/* webpackChunkName: "views" */ '@/views/supplier/supplier/edit'),                    
      },
    ]
  },
  {
    path: '/finance',
    component: Layout,
    redirect: '',
    children: [
      {
        path: 'backmoney/edit',
        name: '编辑回款',
        component: () => import(/* webpackChunkName: "views" */ '@/views/finance/backmoney/edit'),
      },
    ]
  },
  {
    path: '/frame',
    component: Layout,
    redirect: '',
    children: [
      {
        path: 'see',
        name: '查看框架协议',
        component: () => import(/* webpackChunkName: "views" */ '@/views/frame/see'),
      }
    ]
  },
  {
    path: '/check',
    component: Layout,
    redirect: '',
    children: [
      {
        path: 'contract-start/assess',
        name: '合同启动审批',
        component: () => import(/* webpackChunkName: "views" */ '@/views/approve/contract/start/assess'),
      },
      {
        path: 'contract-end/assess',
        name: '合同结案审批',
        component: () => import(/* webpackChunkName: "views" */ '@/views/approve/contract/end/assess'),
      },
      {
        path: 'contract-close/assess',
        name: '合同关闭审批',
        component: () => import(/* webpackChunkName: "views" */ '@/views/approve/contract/close/assess'),
      },
      {
        path: 'contract-settlement/assess',
        name: '合同博主结算条件审批',
        component: () => import(/* webpackChunkName: "views" */ '@/views/approve/contract/settlement/assess'),
      },
      {
        path: 'custom/assess',
        name: '客户审批',
        component: () => import(/* webpackChunkName: "views" */ '@/views/approve/custom/component/assess'),
      },
      {
        path: 'invoice/assess',
        name: '开票审批',
        component: () => import(/* webpackChunkName: "views" */ '@/views/approve/invoice/component/assess'),
      },
      {
        path: 'sealed/assess',
        name: '框架协议盖章审批',
        component: () => import(/* webpackChunkName: "views" */ '@/views/approve/frameworkSealed/component/assess'),
      },
      {
        path: 'pay/blogger',
        name: '博主结算付款审批',
        component: () => import(/* webpackChunkName: "views" */ '@/views/approve/bloggerPay/component/assess'),
      },
      {
        path: 'pay/order',
        name: '代下单付款审批',
        component: () => import(/* webpackChunkName: "views" */ '@/views/approve/orderPay/component/assess'),
      },
      {
        path: 'pay/point',
        name: '返点付款审批',
        component: () => import(/* webpackChunkName: "views" */ '@/views/approve/pointPay/component/assess'),
      },
      {
        path: 'pay/other',
        name: '其他付款审批',
        component: () => import(/* webpackChunkName: "views" */ '@/views/approve/otherPay/component/assess'),
      },
      {
        path: 'blogger/assess',
        name: '博主审批',
        component: () => import(/* webpackChunkName: "views" */ '@/views/approve/blogger/component/assess'),
      },
      {
        path: 'media/assess',
        name: '资源审批',
        component: () => import(/* webpackChunkName: "views" */ '@/views/approve/media/component/assess'),
      },
      {
        path: 'delivery/add/assess',
        name: '投放记录创建审批',
        component: () => import(/* webpackChunkName: "views" */ '@/views/approve/delivery/add/component/assess'),
      },
      {
        path: 'delivery/del/assess',
        name: '投放记录删除审批',
        component: () => import(/* webpackChunkName: "views" */ '@/views/approve/delivery/delete/component/assess'),
      },
      {
        path: 'invoiceBatch/assess',
        name: '批量开票审批',
        component: () => import(/* webpackChunkName: "views" */ '@/views/approve/invoiceBatch/component/assess'),
      },
      {
        path: 'invoiceBatchCancel/assess',
        name: '批量开票作废审批',
        component: () => import(/* webpackChunkName: "views" */ '@/views/approve/invoiceBatchCancel/component/assess'),
      },
      {
        path: 'invoiceCancel/assess',
        name: '商务合同开票作废审批',
        component: () => import(/* webpackChunkName: "views" */ '@/views/approve/invoiceCancel/component/assess'),
      },
    ]
  },
  {
    path: '/pay',
    component: Layout,
    redirect: '',
    children: [
      {
        path: "blogger/show",
        name: '投放记录详情',
        component: () => import(/* webpackChunkName: "views" */ '@/views/pay/blogger/show'),
      },
      {
        path: "blogger/batchform",
        name: '填写发票信息',
        component: () => import(/* webpackChunkName: "views" */ '@/views/pay/blogger/component/assess'),
      },
    ]
  },
  {
    path: '/custom',
    component: Layout,
    redirect: '',
    children: [
      {
        path: 'custom-list',
        name: '客户列表',
        component: () => import(/* webpackChunkName: "views" */ '@/views/custom/index'),
      },
      {
        path: 'add',
        name: '创建客户',
        component: () => import(/* webpackChunkName: "views" */ '@/views/custom/add'),
      },
      {
        path: 'edit',
        name: '编辑客户',
        component: () => import(/* webpackChunkName: "views" */ '@/views/custom/edit'),
      },
      {
        path: 'show',
        name: '查看客户',
        component: () => import(/* webpackChunkName: "views" */ '@/views/custom/show'),
      }
    ]
  },
  {
    path: '/datacenter',
    component: Layout,
    redirect: '',
    children: [
      {
        path: 'dataList',
        name: '数据导出',
        component: () => import(/* webpackChunkName: "views" */ '@/views/datacenter/index'),
      },
    ]
  },
  {
    path: '/internal',
    component: Layout,
    redirect: '',
    children: [
      {
        path: 'details',
        name: '订单详情',
        component: () => import(/* webpackChunkName: "views" */ '@/views/internal/order/details'),
      },
    ]
  },
  {
    path: '/check',
    component: Layout,
    redirect: '',
    children: [
      {
        path: 'examination',
        name: '合同附件盖章审批',
        component: () => import(/* webpackChunkName: "views" */ '@/views/custom/sealApproval/details'),
      },
    ]
  },
  {
    path: '/brandContract',
    component: Layout,
    redirect: '',
    children: [
      {
        path: 'edit',
        name: '品牌合同管理',
        component: () => import(/* webpackChunkName: "views" */ '@/views/brandContract/edit'),
      },
    ]
  },
  {
    path: '/brandContract',
    component: Layout,
    redirect: '',
    children: [
      {
        path: 'add',
        name: '创建品牌合同',
        component: () => import(/* webpackChunkName: "views" */ '@/views/brandContract/add'),
      },
    ]
  },
  {
    path: '/check',
    component: Layout,
    redirect: '',
    children: [
      {
        path: 'contractApproval',
        name: '审批',
        component: () => import(/* webpackChunkName: "views" */ '@/views/approve/brand/contractApproval'),
      },
    ]
  },
  {
    path: '/blogger',
    component: Layout,
    redirect: '',
    children: [
      {
        path: 'bzList/edit',
        name: '编辑博主',
        component: () => import(/* webpackChunkName: "views" */ '@/views/blogger/bzList/add'),
      },
    ]
  },
  {
    path: '/approve',
    redirect: '',
    children: [
      {
        path: 'success',
        name: '审批完成',
        component: () => import(/* webpackChunkName: "views" */ '@/page/success'),
      },
    ]
  },
  {
    path: '/businessManagement',
    component: Layout,
    redirect: '',
    children: [
      {
        path: 'business/edit',
        name: '编辑商务供应商',
        component: () => import(/* webpackChunkName: "views" */ '@/views/supplier/business/edit'),                    
      },
    ]
  },
  {
    path: '/check',
    component: Layout,
    redirect: '',
    children: [
      {
        path: 'businessApproval/assess',
        name: '商务供应商审批',
        component: () => import(/* webpackChunkName: "views" */ '@/views/approve/business/component/assess'),                    
      },
    ]
  },
  {
    path: '/wx',
    component: Layout,
    redirect: '',
    children: [
      {
        path: 'project',
        name: '通告编辑',
        component: () => import(/* webpackChunkName: "views" */ '@/views/wxProject/edit'),
      },
      {
        path: 'project/index',
        name: '通告信息',
        component: () => import(/* webpackChunkName: "views" */ '@/views/wxProject/index'),
      },
      {
        path: 'blogger/edit',
        name: '博主编辑',
        component: () => import(/* webpackChunkName: "views" */ '@/views/wxBlogger/show'),
      },
      {
        path: 'blogger/index',
        name: '博主列表',
        component: () => import(/* webpackChunkName: "views" */ '@/views/wxBlogger/index'),
      },
    ]
  },

]
